module.exports = __webpack_public_path__ + "img/2.dc0cdf32.jpg";